export const administrationAccountsHeadOfficeQualityManagers = {
    template: require('./administration-accounts-head-office-quality-managers.html'),
    controller: 'AdministrationAccountsHeadOfficeQualityManagersController'
};
